import { API } from "."
import type { ReportHistoryEntry, CreateReportHistoryPayload } from "@/types/reportHistory"

const BASE_PATH = "/reports/v2/history"

/** 리포트 조회 기록 생성 */
export async function createReportHistory(payload: CreateReportHistoryPayload) {
  return await API.post<ReportHistoryEntry>(BASE_PATH, payload)
}

/** 최근 리포트 조회 기록 목록 */
export async function readReportHistory(limit = 20) {
  return await API.get<ReportHistoryEntry[]>(BASE_PATH, {
    params: { limit },
  })
}
